<template>
    <base-viewer>
        <Navbar />
        <NavDrawer :hover="true"/>
        <iframe ref="webView" style="min-height:calc(100% - 77px)" frameborder scrolling="no" :height="webViewHeight" width="100%" :src="webSrc"></iframe>
        <Footer />
    </base-viewer>
</template>

<script>
import Navbar from "@/core/components/Navbar.vue";
import Footer from "@/core/components/footer";
import NavDrawer from '@/core/components/navigation';

export default {
  data() {
    return {
      webSrc: '',
      webViewHeight: '90%',
    }
  },
  components: {
    Navbar,
    Footer,
    NavDrawer
  },
  methods:{

  },
  mounted() {
    let wv = this.$refs.webView;
    //通过Nginx反向代理https://webapp.makjust.com解决跨域代理问题，并根据传参确定版本。
    this.webSrc = `https://${window.location.host}/proxy-webapp/v${this.$route.query.v ? this.$route.query.v : '1'}/${this.$route.params.pathMatch}`;
    wv.onload = () => {
      // console.log('iFrameLoaded');
      try {
        let viewH = wv.contentWindow.outerHeight
        if(viewH > (window.outerHeight - 77))
          this.webViewHeight = wv.contentWindow.outerHeight + 'px';
      } catch (error) {
        console.log('Unknow height.');
      }
      console.log();
    }
    wv.onresize = () => {
      // console.log('iFrameResized');
    }
  },
  destroyed() {
    window.onresize = null;
  },
};
</script>